import { useEffect, useState } from 'react'

import { Form } from 'react-bootstrap'
import ReactSelect from 'react-select'
import { toast } from 'react-toastify'
import { CheckCircleFill } from 'react-bootstrap-icons'

import { Modable } from '../../../../components/Modable'
import { CustomButton } from '../../../../components/CustomButton'

import SubcategoriesService from '../../../../services/database/SubcategoriesService'
import CategoriesService from '../../../../services/database/CategoriesService'

import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

import { Container, Footer } from './styles'

export function ModalCreate({ isOpen, onClose, loadSubcategories }) {
  const [subcategoryName, setSubcategoryName] = useState('')
  const [categoryId, setCategoryId] = useState('')
  const [isCreateRequestLoading, setIsCreateRequestLoading] = useState(false)

  const [categories, setCategories] = useState([])
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(true)

  const optionsCategories = categories.map((category) => ({
    label: category.categoria,
    value: category.id_categoria,
  }))

  async function loadCategories() {
    try {
      setIsCategoriesLoading(true)

      const data = await CategoriesService.getAll()

      setCategories(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao listar as categorias!')
    } finally {
      setIsCategoriesLoading(false)
    }
  }

  async function handleCreateSubcategory() {
    try {
      setIsCreateRequestLoading(true)

      await SubcategoriesService.create({
        name: subcategoryName,
        categoryId,
      })

      loadSubcategories()
      toast.success('Subcategoria criada com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao criar a subcategoria!')
    } finally {
      setIsCreateRequestLoading(false)
      onClose()
    }
  }

  function resetStates() {
    setSubcategoryName('')
    setIsCreateRequestLoading(false)
  }

  useEffect(() => {
    resetStates()
    loadCategories()
  }, [])

  return (
    <Modable
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
    >
      <Container>
        <div>
          <h1>Cadastrar Subcategoria</h1>

          <Form.Control
            value={subcategoryName}
            onChange={(e) => setSubcategoryName(e.target.value)}
            placeholder="Digite o nome..."
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (e.target.value) {
                  handleCreateSubcategory()
                }
              }
            }}
            style={{
              marginBottom: 10,
            }}
          />

          <ReactSelect
            value={categoryId}
            onChange={setCategoryId}
            isDisabled={isCategoriesLoading}
            placeholder={
              isCategoriesLoading ? 'Carregando...' : 'Selecione uma categoria'
            }
            options={optionsCategories}
          />
        </div>

        <Footer>
          <CustomButton
            isDisabled={!subcategoryName}
            title="Cadastrar"
            color="#0d9a04"
            onClick={handleCreateSubcategory}
            isLoading={isCreateRequestLoading}
            isLoadingText="Cadastrando..."
          >
            <CheckCircleFill />
          </CustomButton>
        </Footer>
      </Container>
    </Modable>
  )
}
